export default __webpack_public_path__ + "splash-03.abc65.svg";